import { useQuery } from '@apollo/client';
import { useMemo } from 'react';
import { GET_MEMBERS_FOR_IDS_QUERY } from '@frontend/app/queries';
import {
  GetMembersForIdsQuery,
  GetMembersForIdsQueryVariables,
} from '@frontend/app/queries/types/GetMembersForIdsQuery';

/**
 * Hook for fetching members by their IDs
 * @param memberIds Array of member IDs to fetch
 * @returns Object with members data, loading state, and error
 */
export const useMembersByIds = (memberIds?: number[]) => {
  const { data, loading, error } = useQuery<GetMembersForIdsQuery, GetMembersForIdsQueryVariables>(
    GET_MEMBERS_FOR_IDS_QUERY,
    {
      variables: {
        ids: memberIds,
        take: 100,
        skip: 0,
      },
      skip: !memberIds || memberIds.length === 0,
      fetchPolicy: 'no-cache',
    }
  );

  // Memoize the result to prevent unnecessary re-renders
  const result = useMemo(() => ({
    data,
    loading,
    error
  }), [data, loading, error]);

  return result;
};
